    $(function() {
        var xhrRunning = false;
        var Forms = {
            init() {
              this.setEvents( $(document).find( '.form.global' ) );
            },
            setEvents(form) {
                const self = this;
                const buttonSubmit = form.find( 'input[type="submit"], button[type="submit"]' );
                form = buttonSubmit.closest( 'form' );
                $( 'input', form ).removeAttr( 'autocomplete' );
                if (form.length === 0) return;
                buttonSubmit.click(function(e) {
                    e.preventDefault();
                    form = $(this).closest( 'form' );
                    form.find( '.error' ).remove();
                    form.find( '.message' ).html( '' ).hide();
                    if ( Utils.validateForm(form) ) {
                        if (xhrRunning)
                            return;
                        if ( form.attr( 'action' ) ) {
                          form.submit();
                          return;
                        }
                        self.submit(form);
                        return;
                    }
                    return;
                });
                form.on( 'keyup, click', 'input[required]:not(.optional)', function(e) {
                    e.preventDefault();
                    var error_msgs = form.find( '.error' );
                    if ( error_msgs.length > 0 ) {
                        error_msgs.remove();
                    }
                });
                $( 'input[required]:not(.optional)', form ).keypress(function(e) {
                    var key = e.which;
                    if ( key == 13 ) {
                        $(this).closest( 'form' ).find( 'input[type="submit"], button[type="submit"]' ).trigger( 'click' );
                        return false;
                    }
                });
            },
            submit(form) {
                const self = this;
                const $buttonSubmit = form.find( 'input[type="submit"], button[type="submit"]' );
                const $textHolder   = $buttonSubmit.find( '.text' );
                const action        = form.find( 'input[name="action"]' ).val();
                const email         = form.find( 'input[name="email"]' ).val();
                const $message      = $( '.subscribe .block .text' );
                if ( ! action ) {
                    return;
                }
                const url     = 'https://alt.hemway.com/api/index.php/subscribe?email=' + email;
                const payload = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow'
                };
                $textHolder.text( 'Processing' );
                fetch( url, payload )
                .then( response => response.json() )
                .then( response => {
                    if ( response.success ) {
                        $textHolder.text( 'Successful' );
                    }
                    if ( response.message ) {
                        $message.find( 'p.alt' ).text( response.message );
                        $message.removeClass( 'hidden' );
                    }
                }).finally(() => {
                    setTimeout(() => {
                        $textHolder.text( 'Sign Up' );
                        self.resetForm(form);
                    }, 600);
                })
                .catch( error => {
                    console.error( 'Error:', error );
                    return [];
                });
            },
            resetForm(form) {
                form[0].reset();
                form.find( 'button[type="submit"], input[type="submit"]' ).removeAttr( 'disabled' );
            },
        };
        Forms.init();
    });
